export const environment = {
  production: true,
  url_admission_api: 'https://admin.rh.homolog.acesso.io/svc2',
  url_ongoing_api: 'https://api.collaborators.people.uat.private.unico.run/api/v1',
  url_admission_form_api: 'https://form.rh.homolog.acesso.io/svc2',
  url_benefits_api: 'https://admin.rh.homolog.acesso.io/api/benefits/v1',
  url_routing_api: 'https://admin.rh.homolog.acesso.io/api/routing/v1',
  cdn_url: 'https://admin.rh.homolog.acesso.io/cdn2',
  identity_url: 'https://identityhomolog.acesso.io',
  sign_url: 'https://signhom.acesso.io',
  svc1_url: 'https://admin.rh.homolog.acesso.io/svc2',
  sign_id: 'DB8EF2DD966F2CE9F3237F1A1746143B346393D373C7268FFC32759DE06597EA',
  segment_key: 'aJSx6ITwDTBcFEq6je022Y0UrC52Khm1',
  admission_url: 'https://admin.rh.homolog.acesso.io',
  ongoing_url: 'https://collaborators.rh.homolog.acesso.io',
  benefits_url: 'https://benefits.rh.homolog.acesso.io',
  redirect_uri: 'https://admin.rh.homolog.acesso.io/preauthorize',
  redirect_uri_admission: 'https://admin.rh.homolog.acesso.io/preauthorize',
  redirect_uri_ongoing: 'https://collaborators.rh.homolog.acesso.io/preauthorize',
  redirect_uri_benefits: 'https://benefits.rh.homolog.acesso.io/preauthorize',
  base_sign_url: '',
  productId: "99c3dfc5-7518-4d7c-9e75-e54d920721fd",
  launchDarklyClientId: '63ea74d9be4a22130ad5aa07',
  url_benefits: 'https://benefits.rh.homolog.acesso.io',
  mixpanel_token: 'f4069d9b550ea08e34089810c2abd5be',
};
